<template>
  <div class="grid gap-8">
    <h1 class="text-primary-950 font-bold md:text-2xl">
      <i18n-t
        v-if="event.teacher"
        keypath="course.page.header.title"
        tag="span"
      >
        <template #title>
          <span
            class="font-title mb-4 block max-w-[950px] text-3xl leading-snug sm:text-4xl/tight md:text-5xl/tight"
          >
            {{ event.course.title }}
          </span>
        </template>

        <template #teacherFullName>
          <strong class="font-bold">
            {{ event.teacher.full_name }}
          </strong>
        </template>

        <template #teacherJob>
          <span class="mr-2 font-normal">
            {{ event.teacher.job }}
          </span>

          <span class="inline-flex gap-2 align-middle">
            <teacher-companies-logos
              :companies="event.teacher.companies"
              :height="35"
            />
          </span>
        </template>
      </i18n-t>
      <template v-else>
        <span
          class="font-title mb-8 block max-w-[950px] text-3xl leading-snug sm:text-4xl/tight md:text-5xl/tight"
        >
          {{ event.course.title }}
        </span>

        <ul
          class="flex flex-wrap items-center gap-x-6 gap-y-3 text-base font-normal"
        >
          <li v-for="teacher in event.teachers" :key="teacher.id">
            <figure class="grid grid-cols-[auto_1fr] gap-2">
              <app-user-avatar
                :avatar-url="teacher.avatar_url"
                :name="teacher.full_name"
                :size="48"
                tile
              />

              <figcaption>
                <p class="text-lg font-semibold">
                  {{ teacher.full_name }}
                </p>
                <p class="mb-1 text-sm">
                  {{ teacher.job }}
                </p>

                <p>
                  <teacher-companies-logos
                    :companies="teacher.companies"
                    :height="20"
                    variant="flat"
                  />
                </p>
              </figcaption>
            </figure>
          </li>
        </ul>
      </template>
    </h1>

    <div class="flex flex-wrap items-center gap-2">
      <course-online-type-chip v-if="event.is_online" />

      <course-format-chip :format="event.course.format" />

      <place-address-chip
        v-if="event.place"
        :address="event.place.address"
        class="lg:hidden"
        field="city"
      />
      <course-language-chip
        data-cy-course-languages
        :languages="event.course.languages"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { type EventView } from "#imports";

defineProps<{
  event: EventView;
}>();
</script>
